import * as React from 'react';
import { SVGProps } from 'react';

const IconLineAndBarChartSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m20.707 6.293-4.79-4.79-4.092 5.116-4-3-4.606 5.756 1.562 1.25 3.394-4.243 4 3 3.908-4.885 3.21 3.21 1.414-1.414ZM15 10v11h2V10h-2Zm-8 1v10h2V11H7Zm-4 3v7h2v-7H3Zm8-2v9h2v-9h-2Zm8 2v7h2v-7h-2Z" />
  </svg>
);
export default IconLineAndBarChartSizeM;
